import Header from "./header1";
import Footer from "./footer";
import { RWebShare } from "react-web-share";
import ManageAccount from "../Employee/manageAccount";
import { useNavigate, useParams } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  requestEmpLogin,
  requestFormField,
  requestEmployeeAddQuestion,
  requestEmployeeAllQuestion,
  requestEmployeeQuestion,
  requestEmployeeDeleteQuestion,
  requestEmployeeEditQuestion,
} from "../Redux/actions";
import Swal from "sweetalert2";
import WOW from "wowjs";
import Breadcrumbs from "../Section/breadcrumbsSection";

function Question(props) {

  const [pagination, setpagination] = useState({});
  const navigate = useNavigate();
  const [change, setchange] = useState(false)
  const [pages, setpages] = useState([]);
  const [page_size, setpage_size] = useState(0);
  const [error, seterror] = useState("");
  const [errortype, seterrorType] = useState("");
  const [errorTags, seterrorTags] = useState("");
  const [errorRole, seterrorRole] = useState("");
  const [errorExperience, seterrorExperience] = useState("");
  const [id, setid] = useState(0);
  const [question, setquestion] = useState([]);
  const [adddata, setadddata] = useState({
    name: "",
    tags: "",
    role: "",
    experience: "",
  });
  const [editdata, seteditdata] = useState({
    name: "",
    tags: "",
    role: "",
    experience: "",
  });
  const params = useParams();
  const [addmodal, setaddModal] = useState(false);
  const [editmodal, seteditModal] = useState(false);
  const [emp, setEmp] = useState({});
  const [functional_areas, setfunctional_areas] = useState([]);

  function validateadd() {
    let formIsValid = false;
    if (!adddata["name"]) {
      formIsValid = false;
      seterror("*Enter question.");
    } else if (typeof adddata["name"] !== "undefined") {
        formIsValid = true;
        seterror("");
    }
    return formIsValid;
  }

  function tagsadd() {
    let formIsValid = false;
    if (!adddata["tags"]) {
      formIsValid = false;
      seterrorTags("*Enter tags by comma.");
    } else {
      formIsValid = true;
      seterrorTags("");
    }
    return formIsValid;
  }

  function typeadd() {
    let formIsValid = false;
    if (!adddata["type"]) {
      formIsValid = false;
      seterrorType("*Select Type.");
    } else {
      formIsValid = true;
      seterrorType("");
    }
    return formIsValid;
  }

  function roleadd() {
    let formIsValid = false;
    if (!adddata["role"]) {
      formIsValid = false;
      seterrorRole("*Enter role.");
    } else {
      formIsValid = true;
      seterrorRole("");
    }
    return formIsValid;
  }
  function experienceadd() {
    let formIsValid = false;
    if (!adddata["experience"]) {
      formIsValid = false;
      seterrorExperience("*Enter experience.");
    } else {
      formIsValid = true;
      seterrorExperience("");
    }
    return formIsValid;
  }

  function validateAddForm() {
    console.log('in validate add fom');
    let validate = validateadd(); let tags = tagsadd(); let role = roleadd(); let experience = experienceadd();
    let valid = validate && tags && role && experience;
    return valid;
  }
  
  function validateedit() {
    let formIsValid = false;
    if (!editdata["name"]) {
      formIsValid = false;
      seterror("*Enter question name.");
    } else if (typeof editdata["name"] !== "undefined") {      
        formIsValid = true;
        seterror("");
    }
    return formIsValid;
  }

  function typeedit() {
    let formIsValid = false;
    if (!editdata["type"]) {
      formIsValid = false;
      seterrorType("*Select Type.");
    } else {
      formIsValid = true;
      seterrorType("");
    }
    return formIsValid;
  }

  function tagsedit() {
    let formIsValid = false;
    if (!editdata["tags"]) {
      formIsValid = false;
      seterrorTags("*Enter tags.");
    } else {
      formIsValid = true;
      seterrorTags("");
    }
    return formIsValid;
  }

  function roleedit() {
    let formIsValid = false;
    if (!editdata["role"]) {
      formIsValid = false;
      seterrorRole("*Enter role.");
    } else {
      formIsValid = true;
      seterrorRole("");
    }
    return formIsValid;
  }

  function experienceedit() {
    let formIsValid = false;
    if (!editdata["experience"]) {
      formIsValid = false;
      seterrorExperience("*Enter experience.");
    } else {
      formIsValid = true;
      seterrorExperience("");
    }
    return formIsValid;
  }

  function validateEditForm() {
    let validate = validateedit(); let tags = tagsedit(); let role = roleedit(); let experience = experienceedit();
    let valid = validate && tags && role && experience;
    return valid;
  }
  function onchangeadddata(e) {
    setadddata((adddata) => ({
      ...adddata,
      [e.target.name]: e.target.value,
    }));
  }
  function onchangeeditdata(e) {
    seteditdata((editdata) => ({
      ...editdata,
      [e.target.name]: e.target.value,
    }));
  }

  const addtoggle = () => setaddModal(!addmodal);
  const saveaddtoggle = (e) => {
    e.preventDefault();
    
    if (validateAddForm()) {
      console.log('questionssddf sdfdfsfsdsdd');
      props.requestEmployeeAddQuestion({
        data: {
          user_id: emp.id,
          name: adddata.name,
          tags: adddata.tags,
          role: adddata.role,
          experience: adddata.experience,
        },
      });
      setadddata({
        name: "",
        tags: "",
        role: "",
        experience: "",
      });
      addtoggle();
    }
  };

  useEffect(() => {
    let empLoginData = props.employee.empLoginData;
    if (empLoginData !== undefined) {
      if (empLoginData?.data?.status == "success") {
        setEmp(empLoginData.data.data);
        props.requestFormField({
          token: empLoginData.data.data.token,
        });
      } else {
        localStorage.setItem("link", "/question");
        navigate("/emplogin");
      }
    } else {
      localStorage.setItem("link", "/question");
      navigate("/emplogin");
    }
  }, [props.employee.empLoginData]);

  useEffect(() => {
    let addQuestionData = props.data.addQuestionData;
    if (addQuestionData !== undefined) {
      if (addQuestionData.data) {
        Swal.fire({
          title: 'Good job!',
          text: 'Question added successfully..',
          icon: 'success'
        });
        setchange(!change)
      }
    }
    props.data.addQuestionData = undefined;
  }, [props.data.addQuestionData]);

  useEffect(() => {
    let formfieldData = props.employee.formfieldData;
    if (formfieldData !== undefined) {
      if (formfieldData?.data?.status == "success") {
        setfunctional_areas(formfieldData.data.data.functional_areas);
      }
    }
  }, [props.employee.formfieldData]);

  const edittoggle = (id) => {
    if (editmodal === true) {
      seteditModal(!editmodal);
    } else {
      seteditModal(!editmodal);
      setid(id);
      seteditdata({
        name: " ",
        tags: " ",
        role: " ",
        experience: " ",
      });
      props.requestEmployeeQuestion({
        id: id,
      });
    }
  };

  useEffect(() => {
    let question = props.data.questionData;
    if (question !== undefined) {
      if (question.data) {
        seteditdata(question.data.data.Question[0]);
      }
    }
  }, [props.data.questionData]);

  const saveedittoggle = (e) => {
    e.preventDefault();
    if (validateEditForm()) {
      props.requestEmployeeEditQuestion({
        id: id,
        data: {
          name: editdata.name,
          tags: editdata.tags,
          role: editdata.role,
          experience: editdata.experience,
        },
      });
      seteditdata({
        name: "",
        tags: "",
        role: "",
        experience: "",
      });
      setid(0);
      edittoggle();
    }
  };

  useEffect(() => {
    let editQuestionData = props.data.editQuestionData;
    if (editQuestionData !== undefined) {
      if (editQuestionData.data) {
        Swal.fire({
          title: 'Good job!',
          text: 'Question updated successfully..',
          icon: 'success'
        });
        setchange(!change)
      }
    }
    props.data.editQuestionData = undefined;
  }, [props.data.editQuestionData]);

  useEffect(() => {
    props.requestEmployeeAllQuestion({
      page: params.page,
      page_size: params.page_size,
    });
    setpage_size(params.page_size);
  }, [params.page, params.page_size, change]);

  function onChangePageSize(e) {
    setpage_size(e.target.value);
    if (e.target.value > 0) {
      navigate(`/question/question/1/${e.target.value}`);
    }
  }

  useEffect(() => {
    new WOW.WOW().init();
    localStorage.removeItem("link");
  }, []);

  useEffect(() => {
    let allQuestionData = props.data.allQuestionData;
    if (allQuestionData !== undefined) {
      if (allQuestionData.data) {
        setquestion(allQuestionData.data.data);
        setpagination(allQuestionData.data.meta);
        if (allQuestionData.data.meta.last_page < 5) {
          let array = [];
          Array.from(Array(allQuestionData.data.meta.last_page), (e, i) => {
            array.push(i + 1);
          });
          setpages(array);
        } else {
          let array = [];
          if (allQuestionData.data.meta.current_page <= 3) {
            array.push(1, 2, 3, 4, 5);
            setpages(array);
          } else if (
            allQuestionData.data.meta.last_page -
            allQuestionData.data.meta.current_page <=
            2
          ) {
            array.push(
              allQuestionData.data.meta.last_page - 4,
              allQuestionData.data.meta.last_page - 3,
              allQuestionData.data.meta.last_page - 2,
              allQuestionData.data.meta.last_page - 1,
              allQuestionData.data.meta.last_page
            );
            setpages(array);
          } else {
            array.push(
              Number(allQuestionData.data.meta.current_page) - 2,
              Number(allQuestionData.data.meta.current_page) - 1,
              allQuestionData.data.meta.current_page,
              Number(allQuestionData.data.meta.current_page) + 1,
              Number(allQuestionData.data.meta.current_page) + 2
            );
            setpages(array);
          }
        }
      }
    }
  }, [props.data.allQuestionData]);
  const CustomUI = ({ onSubmit, onCancel }) => (
    <div
      className="custom-ui"
      style={{
        backgroundColor: "white",
        width: "350px",
        padding: "25px",
        border: "1px solid black",
        margin: "auto",
      }}
    >
      <h3>Are you sure?</h3>
      <p>
        Do you really want to delete this records? This process cannot be
        undone.
      </p>
      <div>
        <button
          onClick={onSubmit}
          style={{ border: "0px", backgroundColor: "green", color: "white", padding: "2px 10px" }}
        >
          Yes
        </button>
        <button
          onClick={onCancel}
          style={{
            border: "0px",
            backgroundColor: "red",
            color: "white",
            marginLeft: "10px",
            padding: "2px 10px"
          }}
        >
          No
        </button>
      </div>
    </div>
  );
  function deletedata(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        props.requestEmployeeDeleteQuestion({
          id: id,
        });
      }
    })
  }

  useEffect(() => {
    let deleteQuestionData = props.data.deleteQuestionData;
    if (deleteQuestionData !== undefined) {
      if (deleteQuestionData.data) {
        Swal.fire({
          title: 'Good job!',
          text: 'Question deleted successfully..',
          icon: 'success'
        });
        setchange(!change)
      }
    }
    props.data.deleteQuestionData = undefined;
  }, [props.data.deleteQuestionData]);

  function printPage() {
    var printContents =
      "<br/><center><h3>Questions</h3></center>" +
      document.getElementById("printme").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }

  return (
    <>
      <div class="container-scroller">
        <Header name="Questions" />
        <div class="container-fluid page-body-wrapper">
          <ManageAccount name="question" />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-sm-12">
                  <div class="home-tab">
                    <div class="row flex-grow">
                      <div class="col-12 grid-margin stretch-card">
                        <div class="card card-rounded">
                          <div class="card-body">
                            <div class="d-sm-flex justify-content-between align-items-start">
                              <div class="btn-wrapper">
                                <RWebShare
                                  data={{
                                    text: "Job Portal",
                                    url: `http://localhost:3000/employee/question/${params.page}/${params.page_size}`,
                                    title: "Job Portal",
                                  }}
                                >
                                  <p class="btn btn-otline-dark align-items-center">
                                    <i class="icon-share"></i> Share
                                  </p>
                                </RWebShare>
                                <button
                                  onClick={printPage}
                                  class="btn btn-otline-dark"
                                >
                                  <i class="icon-printer"></i> Print
                                </button>
                              </div>
                              <div>
                                <button
                                  class="btn btn-primary btn-md text-white mb-0 me-0"
                                  type="button"
                                  onClick={addtoggle}
                                >
                                  Add new question
                                </button>
                                <Modal isOpen={addmodal} toggle={addtoggle}>
                                  <ModalHeader toggle={addtoggle}>
                                    Add Question
                                  </ModalHeader>
                                  <ModalBody>
                                    <form class="forms-sample">
                                      <div class="form-group">
                                        <label>Name</label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          placeholder="Name"
                                          name="name"
                                          value={adddata.name}
                                          onBlur={validateadd}
                                          onChange={onchangeadddata}
                                        />
                                        {error && <p>{error}</p>}
                                        <label>
                                          <br />
                                          Tags
                                        </label>
                                        <input
                                          type="text"
                                          name="tags"
                                          class="form-control"
                                          placeholder="Tags (seperated by comma)"
                                          value={adddata.tags}
                                          onBlur={tagsadd}
                                          onChange={onchangeadddata}
                                        />
                                        {errorTags && <p>{errorTags}</p>}
                                        <label>
                                          <br />
                                          Functional Area
                                        </label>
                                        <select
                                          class="form-select"
                                          name="functional_area"
                                          // value={data.functional_area}
                                          onBlur={roleadd}
                                          onChange={onchangeadddata}
                                        >
                                          <option value="0">Select Functional Area</option>
                                          {functional_areas.map((option) => (
                                            <option value={option.id}>{option.name}</option>
                                          ))}
                                        </select>
                                        {errorRole && <p>{errorRole}</p>}
                                        <label>
                                          <br />
                                          Experience
                                        </label>
                                        <input
                                          type="text"
                                          name="experience"
                                          class="form-control"
                                          placeholder="Experience"
                                          value={adddata.experience}
                                          onBlur={experienceadd}
                                          onChange={onchangeadddata}
                                        />
                                        {errorExperience && <p>{errorExperience}</p>}
                                        <label>
                                          <br />
                                          Question Type
                                        </label>
                                        <select
                                          class="form-select"
                                          name="type"
                                          onBlur={typeadd}
                                          onChange={onchangeadddata}>
                                          <option value="1">Short</option>
                                          <option value="2">Long</option>
                                          <option value="3">Single Options</option>
                                          <option value="4">Multiple Select</option>
                                        </select>
                                      </div>

                                      <button
                                        type="submit"
                                        class="btn btn-primary me-2"
                                        onClick={saveaddtoggle}
                                      >
                                        Submit
                                      </button>
                                      <button
                                        class="btn btn-light"
                                        onClick={addtoggle}
                                      >
                                        Cancel
                                      </button>
                                    </form>
                                  </ModalBody>
                                </Modal>
                              </div>
                            </div>
                            <br />
                            <div class="table-responsive  mt-1" id="printme">
                              <table class="table select-table">
                                <thead>
                                  <tr>
                                    <th>Question</th>
                                    <th>Type</th>
                                    <th>Functional Area</th>
                                    <th>Created At</th>
                                    <th>Updated At</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {question.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <div class="d-flex ">
                                            <div>
                                              <h6>{item.name}</h6>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <p>{item.type}</p>
                                        </td>
                                        <td>
                                          <p>{item.fun_area}</p>
                                        </td>
                                        <td>
                                          <p>{item.created_at.substring(0, 10)}</p>
                                        </td>
                                        <td>
                                          <p>{item.updated_at.substring(0, 10)}</p>
                                        </td>
                                        <td>
                                          <button
                                            class="badge badge-opacity-success"
                                            style={{
                                              border: "0px",
                                              marginLeft: "5px",
                                            }}
                                            onClick={() => {
                                              edittoggle(item.id);
                                            }}
                                          >
                                            <i class="fa fa-pencil-square-o"></i>
                                          </button>
                                          {editmodal === true && (
                                            <Modal
                                              isOpen={editmodal}
                                              toggle={edittoggle}
                                            >
                                              <ModalHeader toggle={edittoggle}>
                                                Edit Question
                                              </ModalHeader>
                                              <ModalBody>
                                                <form class="forms-sample">
                                                  <div class="form-group">
                                                    <label>Name</label>
                                                    <input
                                                      type="text"
                                                      class="form-control"
                                                      placeholder="Name"
                                                      name="name"
                                                      value={editdata.name}
                                                      onBlur={validateedit}
                                                      onChange={
                                                        onchangeeditdata
                                                      }
                                                    />
                                                    {error && <p>{error}</p>}
                                                    <label>
                                                      <br />
                                                      Tags
                                                    </label>
                                                    <input
                                                      type="text"
                                                      name="tags"
                                                      class="form-control"
                                                      placeholder="Tags (seperated by comma)"
                                                      value={editdata.tags}
                                                      onBlur={tagsadd}
                                                      onChange={onchangeadddata}
                                                    />
                                                    {errorTags && <p>{errorTags}</p>}
                                                    <label>
                                                      <br />
                                                      Functional Area
                                                    </label>
                                                    <select
                                                      class="form-select"
                                                      name="functional_area"
                                                      value={editdata.fun_area}
                                                      onBlur={roleadd}
                                                      onChange={onchangeadddata}
                                                    >
                                                      <option value="0">Select Functional Area</option>
                                                      {functional_areas.map((option) => (
                                                        <option value={option.id}>{option.name}</option>
                                                      ))}
                                                    </select>
                                                    {errorRole && <p>{errorRole}</p>}
                                                    <label>
                                                      <br />
                                                      Experience
                                                    </label>
                                                    <input
                                                      type="text"
                                                      name="experience"
                                                      class="form-control"
                                                      placeholder="Experience"
                                                      value={editdata.experience}
                                                      onBlur={experienceadd}
                                                      onChange={onchangeadddata}
                                                    />
                                                    {errorExperience && <p>{errorExperience}</p>}
                                                    <label>
                                                      <br />
                                                      Question Type
                                                    </label>
                                                    <select
                                                      class="form-select"
                                                      name="type"
                                                      onBlur={typeadd}
                                                      value={editdata.type}
                                                      onChange={onchangeadddata}
                                                    >
                                                      <option value="1">Short</option>
                                                      <option value="2">Long</option>
                                                      <option value="3">Single Options</option>
                                                      <option value="4">Multiple Select</option>
                                                    </select>

                                                  </div>

                                                  <button
                                                    type="submit"
                                                    class="btn btn-primary me-2"
                                                    onClick={saveedittoggle}
                                                  >
                                                    Submit
                                                  </button>
                                                  <button
                                                    class="btn btn-light"
                                                    onClick={edittoggle}
                                                  >
                                                    Cancel
                                                  </button>
                                                </form>
                                              </ModalBody>
                                            </Modal>
                                          )}
                                          <button
                                            class="badge badge-opacity-danger"
                                            style={{
                                              border: "0px",
                                              background: "#fea8a9",
                                              marginLeft: "5px",
                                            }}
                                            onClick={() => {

                                              deletedata(item.id);

                                            }}
                                          >
                                            <i class="fa fa-trash"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>

                            <div class="row">
                              <div class="col-10">
                                <div class="pagination center">
                                  <ul class="pagination-list">
                                    {pagination.current_page !== 1 && (
                                      <li>
                                        <a
                                          href={`/employee/question/${params.page - 1
                                            }/${params.page_size}`}
                                        >
                                          <i class="fa fa-long-arrow-left"></i>
                                        </a>
                                      </li>
                                    )}
                                    {pages.map((i) => {
                                      return pagination.current_page === i ? (
                                        <li class="active">
                                          <a
                                            href={`/employee/question/${i}/${params.page_size}`}
                                          >
                                            {i}
                                          </a>
                                        </li>
                                      ) : (
                                        <li>
                                          <a
                                            href={`/employee/question/${i}/${params.page_size}`}
                                          >
                                            {i}
                                          </a>
                                        </li>
                                      );
                                    })}
                                    {pagination.current_page !==
                                      pagination.last_page && (
                                        <li>
                                          <a
                                            href={`/employee/question/${Number(params.page) + 1
                                              }/${params.page_size}`}
                                          >
                                            <i class="fa fa-long-arrow-right"></i>
                                          </a>
                                        </li>
                                      )}
                                  </ul>
                                </div>
                              </div>
                              <div class="col-2">
                                <div class="pagination center">
                                  <form onSubmit={onChangePageSize}>
                                    <div class="form-group">
                                      <input
                                        type="number"
                                        class="form-control"
                                        placeholder={page_size}
                                        name="page_size"
                                        value={page_size}
                                        onChange={onChangePageSize}
                                        style={{ width: "100px" }}
                                      />
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return { employee: state.employee, data: state.data };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      requestEmpLogin, requestFormField,
      requestEmployeeAddQuestion,
      requestEmployeeAllQuestion,
      requestEmployeeQuestion,
      requestEmployeeDeleteQuestion,
      requestEmployeeEditQuestion,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Question);